import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { type ResolveFn } from '@angular/router';
import { catchError, of, tap } from 'rxjs';

import { environment } from '~environments/environment.development';
import { StationsService } from '~services/station.service';
import { BusinessUnit } from '~shared/business-unit';
import { getBuFromQueryParams } from '~utils/business-unit.utils';
import { sentryError } from '~utils/sentry-error';

export const fuelDaysResolver: ResolveFn<string[]> = (route) => {
  const stationsService = inject(StationsService);
  const http = inject(HttpClient);
  const businessUnit = getBuFromQueryParams(route.queryParamMap);
  const fuelDayId = route.queryParamMap.get('fuelDay');
  const isUsFuelDay = businessUnit === BusinessUnit.US && fuelDayId != null && fuelDayId !== '';

  if (!isUsFuelDay) {
    stationsService.isUsFuelDay.set(false);

    return of([]);
  }

  const fuelDayUrl = `${environment.fuelDayBaseUrl}/csconfig/stormap_fuel_day/${fuelDayId}.json`;

  return http.get<string[]>(fuelDayUrl).pipe(
    tap((stations) => {
      if (stations.length === 0) {
        stationsService.isUsFuelDay.set(false);

        return;
      }

      stationsService.isUsFuelDay.set(true);
      stationsService.setFuelDaysParticipatingStations(stations);
    }),
    catchError((error) => {
      stationsService.isUsFuelDay.set(false);
      sentryError(error, 'Fuel Days Resolver', 'S3 API call', { fuelDayUrl });

      return of([]);
    }),
  );
};
